/**
 * StreamLain contact email addresses — Single Source of Truth.
 *
 * All user-facing email references MUST use these constants.
 * Do NOT hardcode email addresses elsewhere.
 */

/** General contact (sales, pricing "contact us" CTA, demo requests) */
export const CONTACT_EMAIL = 'hello@streamlain.de';

/** Technical support (error messages, support links) */
export const SUPPORT_EMAIL = 'hello@streamlain.de';
